import styled from "styled-components";
import ScrollToTop from "../../Util/ScrollToTop";
import PricingPlans from "../pricingAndEarning/PricingPlans";

const Step2 = ({ currentStep }) => {
  if (currentStep !== 2) {
    return null;
  }

  return (
    <StepFormContainer className="pt-lg-4">
      <ScrollToTop />
      <div className="text-dark-gray max-w-800 text-center font-17 my-3 my-md-4">
        These are the earnings you will get when you rent your selected car to
        Fleetsimplify. The less the amount you get, the more you de-risk
        yourself or the better the plan. For detailed explanation of each
        feature/perk listed, read the provided "Agreements" for each plan.
      </div>
      <div className="p-2 max-w-1000 section_wrapper text-center">
        <div className="p-4 pb-0">
          <PricingPlans />
        </div>
      </div>
    </StepFormContainer>
  );
};

export default Step2;

const StepFormContainer = styled.div`
  .section_wrapper {
    background: #fffffe;
    border: 0.5px solid #998d8d;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);
    border-radius: 15px;
    min-height: 500px;
  }
`;
